import { inject, Injectable } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut, User } from '@angular/fire/auth';
import { currentUserSignal } from '../../state/auth.state';
import { resetAppState } from '../../state/reset-app-state';
import { AppStateService } from '../../compartidos/services/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private auth = inject(Auth);
  private appState = inject(AppStateService);

  async login(email: string, password: string): Promise<User> {
    const res = await signInWithEmailAndPassword(this.auth, email, password);
    currentUserSignal.set(res.user);
    return res.user;
  }

  async logout(): Promise<void> {
    await signOut(this.auth);
    resetAppState();

    // Las aplicaciones cargadas son datos de un cliente concreto:
    // no deben sobrevivir al cierre de sesión.
    this.appState.clear();
  }
}
